import {Http} from './index.js'
import Resource from './resource-class'
import {encodeQueryParams, buildUrlFilterParams} from '@/utils/api.js'

class UserDetailsAPI extends Resource {
  constructor () {
    super()
    this.resource = '/user_details'
  }

  getFull ({params = {limit: 100}, filterParams = {}} = {}) {
    const queryParams = [encodeQueryParams(params), buildUrlFilterParams(filterParams)].join('&')
    return Http.get(`${this.resource}/full/query?${queryParams}`)
  }
}
export default new UserDetailsAPI()
